import { isUndefined } from 'lodash';

/**
 * Checks user's permissions
 * Used for DataGrid
 *
 * @param {object} user
 * @param {string} permission
 * @param {bool} isAdmin
 * @returns
 */
function checkPermission(user, permission, isAdmin = false) {
  if (isAdmin) {
    return true;
  }

  if (isUndefined(user) || isUndefined(permission)) {
    return false;
  }

  // if object contains key
  return permission in user.permissions;
}

export default checkPermission;
